import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class FooterSocialLinks extends Component {
  static propTypes = {
    siteSource: PropTypes.string
  };
  state = {
    displayLinks: false
  };

  componentDidMount() {
    // We need the social links to load in the pages after the full page is loaded
    // for SEO reasons
    this.setState({ displayLinks: true }); // eslint-disable-line react/no-did-mount-set-state
  }

  render() {
    const { displayLinks } = this.state;
    const { siteSource } = this.props;
    return (
      <div className="hui-footer__social">
        {displayLinks && (
          <div className="hui-footer__social-icons">
            <p>
              <a
                href="http://www.facebook.com/hipages"
                data-ga-category="Footer"
                data-ga-action="Footer - Clicked Follow Us on Facebook"
                data-ga-label={`Footer - ${siteSource}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span aria-hidden="true" className="social-icon-facebook" />
                <span className="hui-footer__sr-only">hipages on Facebook</span>
              </a>
              <a
                href="https://plus.google.com/103958229420081763823"
                data-ga-category="Footer"
                data-ga-action="Footer - Clicked Find us on Google+"
                data-ga-label={`Footer - ${siteSource}`}
                target="_blank"
                rel="publisher noopener noreferrer"
              >
                <span aria-hidden="true" className="social-icon-google-plus" />
                <span className="hui-footer__sr-only">hipages on Google+</span>
              </a>
              <a
                href="http://www.linkedin.com/company/hipages-group"
                data-ga-category="Footer"
                data-ga-action="Footer - Clicked hipages LinkedIn Profile"
                data-ga-label={`Footer - ${siteSource}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span aria-hidden="true" className="social-icon-linkedin" />
                <span className="hui-footer__sr-only">hipages LinkedIn Profile</span>
              </a>
              <a
                href="http://twitter.com/hipages"
                data-ga-category="Footer"
                data-ga-action="Footer - Clicked Follow Us on Twitter"
                data-ga-label={`Footer - ${siteSource}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span aria-hidden="true" className="social-icon-twitter" />
                <span className="hui-footer__sr-only">hipages on Twitter</span>
              </a>
              <a
                href="http://www.pinterest.com/homeinspire/"
                data-ga-category="Footer"
                data-ga-action="Footer - Clicked hipages on Pinterest"
                data-ga-label={`Footer - ${siteSource}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span aria-hidden="true" className="social-icon-pinterest-p" />
                <span className="hui-footer__sr-only">hipages on Pinterest</span>
              </a>
              <a
                href="https://instagram.com/hipages/"
                data-ga-category="Footer"
                data-ga-action="Footer - Clicked hipages on Instragram"
                data-ga-label={`Footer - ${siteSource}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span aria-hidden="true" className="social-icon-instagram" />
                <span className="hui-footer__sr-only">hipages on Instagram</span>
              </a>
            </p>
          </div>
        )}
      </div>
    );
  }
}
